import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbProps,
} from "@chakra-ui/breadcrumb";
import React from "react";
import { Link } from "react-router-dom";
import { useBusinessContext } from "../../context/ModelContext";

interface BusinessBreadcrumbs {
  children: React.ReactNode;
}
export const BusinessBreadcrumbs = ({
  children,
  ...props
}: BusinessBreadcrumbs & BreadcrumbProps) => {
  const business = useBusinessContext();
  return (
    <Breadcrumb {...props}>
      <BreadcrumbItem>
        <BreadcrumbLink as={Link} to={`/admin/businesses/`}>
          Businesses
        </BreadcrumbLink>
      </BreadcrumbItem>
      <BreadcrumbItem>
        <BreadcrumbLink
          as={Link}
          to={`/admin/businesses/${business.BusinessId}`}
        >
          {business?.DisplayName ?? business.id}
        </BreadcrumbLink>
      </BreadcrumbItem>
      {children}
    </Breadcrumb>
  );
};
